import { render, staticRenderFns } from "./ui-answer.vue?vue&type=template&id=5662408d&scoped=true"
import script from "./ui-answer.vue?vue&type=script&lang=js"
export * from "./ui-answer.vue?vue&type=script&lang=js"
import style0 from "./ui-answer.vue?vue&type=style&index=0&id=5662408d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5662408d",
  null
  
)

export default component.exports